import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { RefreshService } from 'src/app/refresh.service';
import { MatTooltip } from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';
import { RbacService } from 'src/app/services/rbac.service';
import { Permission } from 'src/app/lib/rbac.config';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, MatTooltip, MatTooltipModule]
})
export class HeaderComponent {
  title: any;
  navigation_id: any = 0;
  navigation_title: any;
  title_is_array: any = false;
  showBackButton = false;
  private showRefreshRoutes = [
    '/transactions',
    '/accounts/view',
    '/features/rd-pd-dashboard',
    '/admin/portal-user-logs',
    '/admin/admin-buyload',
    '/admin/admin-tp-pay-bills',
    '/admin/admin-tp-cash-in',
    '/admin/admin-tp-stores',
    '/admin/admin-tp-redeem',
    '/admin/system-maintenance/tier-features'
  ];

  constructor(private router: Router,
    private refreshService: RefreshService,
    private location: Location,
    private toastr: ToastrService,
    private rbac: RbacService
  ) {
    const initialSegments = this.router.url.split('/');
    this.showBackButton = initialSegments.some(segment => !isNaN(Number(segment)) && segment !== '');
    
    const route_title = this.router.url.split('/');
    this.title = route_title[3];

    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
          const urlSegments = ev.url.split('/');
          this.showBackButton = urlSegments.some(segment => !isNaN(Number(segment)) && segment !== '');

           if (ev.url.startsWith('/access-denied')) {
            this.showBackButton = true;
            this.title_is_array = false;
            this.navigation_title = 'Access Denied';
            return;
          }


          this.navigation_id = JSON.parse(localStorage.getItem('navigate'));

          switch (this.navigation_id) {
            case 0:
              this.title_is_array = false;
              this.navigation_title = "DashBoard";
              break;
            case 1:
              this.title_is_array = false;
              this.navigation_title = "Transactions";
              break;
            case 2:
              this.title_is_array = false;
              this.navigation_title = "Accounts";
              break;
            case 3:
              this.title_is_array = true;
              this.navigation_title = [
                {
                  title: "Sku's/billers dashboard",
                  route: "/features/sku-biller-all-transaction",
                  routeMatch: "/features/sku-"
                },
                {
                  title: "push notification",
                  route: "/features/push-notification"
                },
                {
                  title: "announcement",
                  route: "/features/announcement"
                },
                {
                  title: "ads dashboard",
                  route: "/features/ads-dashboard",
                  routeMatch: "/features/ads-"
                },
                {
                  title: "profanity filter",
                  route: "/features/profanity-filter",
                  permission: 'megapay.profanityFilter.view' 
                },
                {
                  title: "auto disable logs",
                  route: "/features/disable-logs",
                  permission: 'megapay.disableLogs.view' 
                },
                {
                  title: "rd/pd dashboard",
                  route: "/features/rd-pd-dashboard"
                },
                {
                  title: "referrals",
                  route: "/features/referrals"
                },
              ].filter(item => !item.permission || this.rbac.hasPermission(item.permission as Permission));
              break;
            case 4:
              this.title_is_array = false;
              this.navigation_title = "KYC";
              break;
            case 5:
              this.title_is_array = false;
              this.navigation_title = 'Cash In / Out';
              break;
            case 6:
              this.title_is_array = true;
              this.navigation_title = [
                {
                  title: "third party logs",
                  route: "/admin/admin-buyload",
                  routeMatch: "/admin/admin-"
                },
                {
                  title: "system maintenance",
                  route: "/admin/system-maintenance/app-maintanance", 
                  routeMatch: "/admin/system-maintenance"       
                },
                {
                  title: "portal account",
                  route: "/admin/portal-account"
                },
                {
                  title: "portal user logs",
                  route: "/admin/portal-user-logs"
                },
              ];
              break;
            case 7:
              this.title_is_array = true;
              this.navigation_title = [
                {
                  title: "summary reports",
                  route: "/reports/reports-summary"
                },
                {
                  title: "daily sales reports",
                  route: "/reports/reports-daily-sales"
                },
                {
                  title: "top user",
                  route: "/reports/reports-top-user"
                },
                {
                  title: "referal commission",
                  route: "/reports/reports-referal-comission"
                }, 
                // not yet know what to do with this page
                // {
                //   title: "branch commission",
                //   route: "/reports/reports-branch-comission"
                // },
              ];
              break;
            default:
              this.title_is_array = false;
              this.navigation_title = "Unknown";
              break;
          }
      }
    });
  }

  onBackClick() {
    if (this.router.url === '/access-denied') {
      localStorage.setItem('navigate', '2');
      this.router.navigate(['/accounts']).catch(() => {
        this.toastr.error('Navigation failed. Please try again.');
      });
      return;
    }

    this.location.back();
  }
  isRouteActive(route: string): boolean {
    return this.router.url.includes(route);
  }
  onRefreshClick() {
    this.refreshService.triggerResetTable();
  }


  get showRefreshButton(): boolean {
    return this.showRefreshRoutes.some(route => this.router.url.includes(route));
  }

}
